import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

type PaidOrder = {
  orderNumber?: string;
  productName?: string;
};

export default function PurchaseSuccess() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const added = params.get('added');
  const [order, setOrder] = useState<PaidOrder | null>(null);
  const [loading, setLoading] = useState(!added);

  useEffect(() => {
    if (added || !sessionId) {
      setLoading(false);
      return;
    }
    const load = async () => {
      let paid: { order?: { orderNumber?: string; product?: { productName?: string } } } | null = null;
      for (let attempt = 0; attempt < 8; attempt += 1) {
        const status = await fetch(`/api/checkout/session-status/${sessionId}`);
        const data = await status.json();
        if (data.payment_status === 'paid') {
          paid = data;
          break;
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
      setOrder({
        orderNumber: paid?.order?.orderNumber,
        productName: paid?.order?.product?.productName,
      });
      setLoading(false);
    };
    load().catch(() => setLoading(false));
  }, [added, sessionId]);

  if (loading) {
    return <div className="container mx-auto px-4 py-16 text-center text-white">{t('checkout.preparing')}</div>;
  }

  const detail = [order?.productName, order?.orderNumber].filter(Boolean).join(' · ');

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="container mx-auto px-6 py-16 max-w-lg text-center">
        <h1 className="text-3xl font-bold text-white mb-4">
          {added ? t('checkout.added_title') : t('checkout.thank_you')}
        </h1>
        {detail && <p className="text-gray-300 mb-4">{detail}</p>}
        <p className="text-gray-300 mb-8">{t('checkout.added_body')}</p>
        <Link
          to="/downloads"
          className="inline-block bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-3 rounded-lg font-semibold"
        >
          {t('checkout.added_installer')}
        </Link>
      </div>
    </div>
  );
}
